/* TODO: t() */
import React, { Component } from 'react';
import TextInput from './TextInput';

// round percents to two decimal places
function formatValue(value: number) {
  return Math.round(value * 100) / 100 + '%';
}

type Props = {
  defaultValue: number;
  onChange?: (value: number) => void;
  disabled?: boolean;
};

type State = {
  value: string;
};

class PercentInput extends Component<Props, State> {
  static defaultProps = {
    defaultValue: 0,
  };

  state: State = {
    value: formatValue(this.props.defaultValue),
  };

  render() {
    let { defaultValue, disabled } = this.props;
    let { value } = this.state;
    return (
      <TextInput
        disabled={disabled}
        placeholder={formatValue(defaultValue)}
        onBlur={this._onBlur}
        value={value}
        onChangeText={this._onChangeText}
      />
    );
  }

  _onBlur = () => {
    let { value } = this.state;
    let number = Math.max(0, Number(value.replace(/%\s*$/, '').trim()));
    let newValue = formatValue(isNaN(number) ? 0 : number);

    this.setState({ value: newValue });

    let { onChange } = this.props;
    onChange && onChange(number);
  };

  _onChangeText = (value: string) => {
    this.setState({ value });
  };
}

export default PercentInput;
